import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Plus, Trash2, Save } from "lucide-react";

export default function AdminCollectionsPage() {
  const [items, setItems] = useState([]);
  const [articles, setArticles] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = async () => {
    const [c, a] = await Promise.all([
      api.get("/admin/collections"),
      api.get("/admin/articles?page_size=200"),
    ]);
    setItems(c.data || []);
    setArticles(a.data.items || []);
  };
  useEffect(() => { load(); }, []);

  const startNew = () => setEditing({ slug: "", title: "", description: "", cover_image_url: "", article_ids: [], order: items.length + 1, is_published: true });
  const save = async () => {
    try {
      if (editing.id) {
        await api.put(`/admin/collections/${editing.id}`, editing);
      } else {
        await api.post("/admin/collections", editing);
      }
      setEditing(null); load();
    } catch (e) { alert(e.response?.data?.detail || e.message); }
  };
  const del = async (id) => { if (!window.confirm("Silinsin mi?")) return; await api.delete(`/admin/collections/${id}`); load(); };

  const toggleArticle = (aid) => setEditing((e) => ({
    ...e, article_ids: e.article_ids.includes(aid) ? e.article_ids.filter((x) => x !== aid) : [...e.article_ids, aid],
  }));

  return (
    <div data-testid="admin-collections">
      <div className="flex items-center justify-between mb-8">
        <div><h1 className="font-serif text-4xl text-cc-text mb-2">Koleksiyonlar</h1>
        <p className="text-sm text-cc-muted">Capella Collections — tematik içerik seçkileri</p></div>
        <button onClick={startNew} className="cc-btn" data-testid="new-collection-btn"><Plus size={14} /> Yeni Koleksiyon</button>
      </div>

      {editing && (
        <div className="bg-white border border-admin-border p-6 mb-8" data-testid="collection-editor">
          <div className="grid md:grid-cols-2 gap-4 mb-4">
            <label className="text-xs text-cc-muted">Slug <input value={editing.slug} onChange={(e) => setEditing({ ...editing, slug: e.target.value })} className="cc-input" placeholder="orn-romantik-kapadokya" /></label>
            <label className="text-xs text-cc-muted">Başlık <input value={editing.title} onChange={(e) => setEditing({ ...editing, title: e.target.value })} className="cc-input" /></label>
          </div>
          <label className="text-xs text-cc-muted block mb-4">Açıklama
            <textarea value={editing.description} onChange={(e) => setEditing({ ...editing, description: e.target.value })} className="cc-input min-h-[80px]" /></label>
          <label className="text-xs text-cc-muted block mb-4">Kapak görsel URL
            <input value={editing.cover_image_url} onChange={(e) => setEditing({ ...editing, cover_image_url: e.target.value })} className="cc-input" /></label>
          <div className="text-xs text-cc-muted mb-2">Yazılar ({editing.article_ids.length})</div>
          <div className="max-h-60 overflow-y-auto border border-admin-border p-3 mb-4">
            {articles.filter((a) => a.status === "published").map((a) => (
              <label key={a.id} className="flex items-center gap-2 py-1 text-sm">
                <input type="checkbox" checked={editing.article_ids.includes(a.id)} onChange={() => toggleArticle(a.id)} />
                <span>{a.translations?.tr?.title} <span className="text-[10px] text-cc-faint">[{a.type}]</span></span>
              </label>
            ))}
          </div>
          <div className="flex gap-3">
            <button onClick={save} className="cc-btn text-[10px] py-2"><Save size={14} /> Kaydet</button>
            <button onClick={() => setEditing(null)} className="cc-btn cc-btn-ghost text-[10px] py-2">İptal</button>
          </div>
        </div>
      )}

      <div className="grid md:grid-cols-2 gap-4">
        {items.map((c) => (
          <div key={c.id} className="bg-white border border-admin-border p-5">
            <div className="flex items-start gap-4">
              {c.cover_image_url && <img src={c.cover_image_url} alt="" className="w-20 h-20 object-cover" />}
              <div className="flex-1">
                <h3 className="font-medium text-cc-text">{c.title}</h3>
                <div className="text-[10px] tracking-overline uppercase text-cc-muted mt-1">{c.article_ids?.length || 0} yazı · /{c.slug}</div>
                <p className="text-xs text-cc-muted mt-2 line-clamp-2">{c.description}</p>
                <div className="flex items-center gap-3 mt-3">
                  <button onClick={() => setEditing(c)} className="text-xs text-cc-sepia hover:underline">Düzenle</button>
                  <button onClick={() => del(c.id)} className="text-xs text-red-600"><Trash2 size={12} /></button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
